<template>
  <v-dialog
    v-model="active"
    persistent
    width="480"
  >
    <v-card
      class="rounded-sm"
      color="primary"
    >
      <v-card-title>¿Eliminar documento?</v-card-title>
      <v-card-actions class="justify-center">
        <v-btn
          color="secondary"
          text
          @click="closeDialog()"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="error"
          :loading="loading"
          :disabled="loading"
          @click="triggerEliminaDocumento()"
        >
          Eliminar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  props: {
    active: {
      type: Boolean,
    },

    idPersonal: {
      type: Number,
      default: 0,
    },

    idDocumento: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      loading: false,
    };
  },

  methods: {
    ...mapActions('documento', ['updateEstatusDocumento', 'fetchDocumentoByPersonal']),

    closeDialog() {
      this.$emit('close');
      this.loading = false;
    },

    async triggerEliminaDocumento() {
      this.loading = true;

      await this.updateEstatusDocumento({
        idPersonal: this.idPersonal,
        idDocumento: this.idDocumento,
      });

      await this.fetchDocumentoByPersonal(this.idPersonal);

      this.closeDialog();
    },
  },
};
</script>

<style></style>
